'use client'

import * as Sentry from '@sentry/nextjs'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import ViverseButton from '@/components/ViverseButton'

type RouteErrorFallbackProps = {
  error: Error & { digest?: string }
  retry: () => void
  segment?: string
}

export default function RouteErrorFallback({ error, retry, segment }: RouteErrorFallbackProps) {
  const t = useTranslations()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  const pageName = segment ? t(`error-boundary.page-name.${segment}`) : ''

  return (
    <main className="flex min-h-[50dvh] w-full flex-col items-center justify-center gap-5 px-4 py-20">
      <h2 className="header-4 text-vive-primary-20 text-center uppercase">
        {t('error-boundary.title', { pageName })}
      </h2>
      <p className="body-1 text-vive-primary-40 max-w-md text-center">
        {t('error-boundary.description', { pageName })}
      </p>
      <ViverseButton variant="colorful" size="large" onClick={retry}>
        {t('error-boundary.retry')}
      </ViverseButton>
    </main>
  )
}
